import { createStyles } from '@core/theme/utils/styles';

export const styles = () =>
  createStyles({
    root: {
      width: '140px',
    },
  });
